// Billing module routes — UPDATED for Epic FE-US-INT-01 §6 Phase 4.
//
// Renames:
//   InvoicesListPage  → BillsListPage   ("history coming soon" empty state)
//   InvoiceDetailPage → BillDetailPage  (latest bill when accountUid in path)
//
// Path conventions:
//   /billing                 — dashboard (read latest bill via ?accountUid=)
//   /billing/bills           — tenant-wide bill-cycle worklist (BillsPage);
//                              ?accountUid= → that account's bill history
//   /billing/bills/:billRef  — bill detail (accountUid → latest bill,
//                              otherwise "coming soon")
//   /billing/settings        — tenant-wide Billing Settings, tabbed (`?tab=`):
//                              general | calendars | schedule | exceptions |
//                              dismissed (BillingSettingsPage)
//   /billing/scheduler       — E52 operational scheduler: status, runs
//                              (BillingSchedulerPage)
//   /billing/scheduler/runs/:runId — E52 one run (SchedulerRunDetailPage)
//
// Legacy redirects (Billing menu regroup): `/billing/calendars`,
// `/billing/exceptions` and `/billing/exceptions/log` → their Settings tab,
// driven by LEGACY_BILLING_SETTINGS_REDIRECTS.
//
// The legacy `/billing/invoices(/:invoiceId)?` paths are intentionally
// dropped — nothing in the FE links to them after rewire.

import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

import {
  LEGACY_BILLING_SETTINGS_REDIRECTS,
  billingSettingsHref,
} from './services/billingSettingsTabs.service';

const BillingDashboardPage = lazy(() =>
  import('./pages/BillingDashboardPage').then((m) => ({ default: m.BillingDashboardPage })),
);
const BillsPage = lazy(() =>
  import('./pages/BillsPage').then((m) => ({ default: m.BillsPage })),
);
const BillDetailPage = lazy(() =>
  import('./pages/BillDetailPage').then((m) => ({ default: m.BillDetailPage })),
);
const BillingSettingsPage = lazy(() =>
  import('./pages/BillingSettingsPage').then((m) => ({ default: m.BillingSettingsPage })),
);
const BillingSchedulerPage = lazy(() =>
  import('./pages/BillingSchedulerPage').then((m) => ({ default: m.BillingSchedulerPage })),
);
const SchedulerRunDetailPage = lazy(() =>
  import('./pages/SchedulerRunDetailPage').then((m) => ({ default: m.SchedulerRunDetailPage })),
);

export const billingRoutes: RouteObject[] = [
  { path: '/billing', element: <BillingDashboardPage /> },
  { path: '/billing/bills', element: <BillsPage /> },
  { path: '/billing/bills/:billRef', element: <BillDetailPage /> },
  { path: '/billing/settings', element: <BillingSettingsPage /> },
  // E52 — billing scheduler (nightly cycles + auto-generate) and run detail.
  { path: '/billing/scheduler', element: <BillingSchedulerPage /> },
  { path: '/billing/scheduler/runs/:runId', element: <SchedulerRunDetailPage /> },
  // Old setup pages → their Settings tab. `replace` so Back skips the hop.
  ...LEGACY_BILLING_SETTINGS_REDIRECTS.map(({ from, tab }) => ({
    path: from,
    element: <Navigate replace to={billingSettingsHref(tab)} />,
  })),
];
